// Traduções do dialog da imagem do Painel de Descarga — coletadas por glob em
// core/i18n/messages.ts. O CONTEÚDO da imagem é pt-BR fixo (painelImagem.ts).
export default {
  pt: {
    'shipments.painelImagem.abrir': 'Gerar imagem do painel',
    'shipments.painelImagem.titulo': 'Imagem do Painel de Descarga',
    'shipments.painelImagem.previewAlt': 'Prévia da imagem do Painel de Descarga',
    'shipments.painelImagem.copiarImagem': 'Copiar imagem',
    'shipments.painelImagem.baixarPng': 'Baixar PNG',
    'shipments.painelImagem.imagemCopiada': 'Imagem do painel copiada.',
    'shipments.painelImagem.copiaImagemFalhou': 'Não foi possível copiar a imagem. Use Baixar PNG.',
    'shipments.painelImagem.baixarFalhou': 'Não foi possível gerar o PNG. Tente novamente.',
    'shipments.painelImagem.copiaNaoSuportada': 'Este navegador não copia imagens. Use Baixar PNG.',
    'shipments.painelImagem.semLinhas': 'Nenhum conjunto na grade para gerar a imagem.',
    'shipments.painelImagem.col.status': 'Status',
    'shipments.painelImagem.col.disponivel': 'Último disponível',
    'shipments.painelImagem.col.motorista': 'Motorista',
    'shipments.painelImagem.col.placa': 'Placa',
    'shipments.painelImagem.col.carreta': 'Carreta',
    'shipments.painelImagem.col.observacoes': 'Observações',
  },
  en: {
    'shipments.painelImagem.abrir': 'Generate panel image',
    'shipments.painelImagem.titulo': 'Unloading Panel image',
    'shipments.painelImagem.previewAlt': 'Preview of the Unloading Panel image',
    'shipments.painelImagem.copiarImagem': 'Copy image',
    'shipments.painelImagem.baixarPng': 'Download PNG',
    'shipments.painelImagem.imagemCopiada': 'Panel image copied.',
    'shipments.painelImagem.copiaImagemFalhou': 'Could not copy the image. Use Download PNG.',
    'shipments.painelImagem.baixarFalhou': 'Could not generate the PNG. Try again.',
    'shipments.painelImagem.copiaNaoSuportada': 'This browser cannot copy images. Use Download PNG.',
    'shipments.painelImagem.semLinhas': 'No sets in the grid to build the image.',
    'shipments.painelImagem.col.status': 'Status',
    'shipments.painelImagem.col.disponivel': 'Last available',
    'shipments.painelImagem.col.motorista': 'Driver',
    'shipments.painelImagem.col.placa': 'Plate',
    'shipments.painelImagem.col.carreta': 'Trailer',
    'shipments.painelImagem.col.observacoes': 'Notes',
  },
  es: {
    'shipments.painelImagem.abrir': 'Generar imagen del panel',
    'shipments.painelImagem.titulo': 'Imagen del Panel de Descarga',
    'shipments.painelImagem.previewAlt': 'Vista previa de la imagen del Panel de Descarga',
    'shipments.painelImagem.copiarImagem': 'Copiar imagen',
    'shipments.painelImagem.baixarPng': 'Descargar PNG',
    'shipments.painelImagem.imagemCopiada': 'Imagen del panel copiada.',
    'shipments.painelImagem.copiaImagemFalhou': 'No se pudo copiar la imagen. Use Descargar PNG.',
    'shipments.painelImagem.baixarFalhou': 'No se pudo generar el PNG. Inténtelo de nuevo.',
    'shipments.painelImagem.copiaNaoSuportada': 'Este navegador no copia imágenes. Use Descargar PNG.',
    'shipments.painelImagem.semLinhas': 'Ningún conjunto en la tabla para generar la imagen.',
    'shipments.painelImagem.col.status': 'Estado',
    'shipments.painelImagem.col.disponivel': 'Último disponible',
    'shipments.painelImagem.col.motorista': 'Conductor',
    'shipments.painelImagem.col.placa': 'Placa',
    'shipments.painelImagem.col.carreta': 'Remolque',
    'shipments.painelImagem.col.observacoes': 'Observaciones',
  },
}
